import script from "./SubscriptionsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionsView.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionsView.vue?vue&type=style&index=0&id=7b6bf2de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b6bf2de"]])

export default __exports__